import { Form, Input, message } from "antd";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getStates } from "../../../api/auth";
import Laptop from "../../../assets/laptop.svg";
import LoginLayout from "../../../components/LoginLayout";
import Button from "../../../components/button";
import Checkbox from "../../../components/checkbox";
import Dropdown from "../../../components/dropdown";
import PhoneNumberInput from "../../../components/phoneNumber";
import { handleAuthRedirect } from "../../../constants/utils";
import { check } from "../../../api/auth";
import InputField from "../../../components/inputField";

const Registration = () => {
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [loader, setLoader] = useState(false);
  const [states, setStates] = useState();

  const navigate = useNavigate();

  const state = async () => {
    const res = await getStates();
    setStates(res);
  };
  const handleCheckboxChange = (e) => {
    setIsCheckboxChecked(e.target.checked);
  };
  const onFinish = async (values) => {
    setLoader(true);
    const payload = {
      email: values.email,
      phoneNumber: values.phoneNumber,
    };
    const res = await check(payload);
    if (res) {
      setLoader(false);
    }
    if (res?.response?.email === true || res?.response?.phoneNumber === true) {
      if (res?.response?.email) {
        message.error("Email already Exit");
      } else if (res?.response?.phoneNumber) {
        message.error("Phone Number already Exit");
      }
    } else {
      const payload = {
        fullName: values.fullName,
        email: values.email,
        phoneNumber: values.phoneNumber,
        agencyName: values.agencyName,
        agencyAddress: values.agencyAddress,
        city: values.city,
        state: values.state,
        postalCode: values.postalCode,
      };
      try {
        navigate("/agent/create-password", { state: { payload: payload } });
      } catch (error) {
        message.error(error?.message);
      } finally {
      }
    }
  };

  useEffect(() => {
    state();
  }, []);
  useEffect(() => {
    const AdminLogin = localStorage.getItem("Login");
    const Token = localStorage.getItem("accessToken");
    if (AdminLogin && Token) {
      handleAuthRedirect(AdminLogin, navigate);
    }
  }, [navigate]);
  return (
    <LoginLayout image={Laptop} altText="engagement-screen">
      <div className="grid md:place-content-center h-screen overflow-y-auto px-5 py-2">
        <div>
          <p className="text-2xl sm:text-3xl lg:text-4xl font-bold">
            Welcome, Register Your Agent Account
          </p>
        </div>
        <Form
          layout="vertical"
          onFinish={onFinish}
          className="md:grid md:grid-cols-2 gap-x-5 mt-5"
        >
          <Form.Item
            name="fullName"
            rules={[
              {
                required: true,
                message: "Please Enter Your Full Name",
              },
            ]}
            label={<span className="text-base font-bold">Full Name</span>}
          >
            <InputField
              placeholder={"Full Name"}
              name={"fullName"}
              type={"text"}
              inputType={"onlyCharacters"}
            />
          </Form.Item>
          <Form.Item
            name="email"
            rules={[
              {
                type: "email",
                message: "Please enter valid email",
              },
              {
                required: true,
                message: "Please Enter Your E-mail!",
              },
            ]}
            label={<span className="text-base font-bold">Email</span>}
          >
            <InputField
              placeholder={"Write Email Address"}
              name={"email"}
              type={"text"}
              inputType={"email"}
            />
          </Form.Item>
          <Form.Item
            name="phoneNumber"
            rules={[
              {
                required: true,
                message: "Please Enter Your Phone Number",
              },
            ]}
            label={<span className="text-base font-bold">Phone Number</span>}
          >
            <PhoneNumberInput name={"phoneNumber"} />
          </Form.Item>
          <Form.Item
            name="agencyName"
            rules={[
              {
                required: true,
                message: "Please Enter Company Name",
              },
            ]}
            label={<span className="text-base font-bold">Company Name</span>}
          >
            <InputField
              placeholder={"Write Company Name"}
              name={"agencyName"}
              type={"text"}
              inputType={"onlyCharacters"}
            />
          </Form.Item>
          <Form.Item
            name="agencyAddress"
            rules={[
              {
                required: true,
                message: "Please Enter Company Address",
              },
            ]}
            className="md:col-span-2"
            label={<span className="text-base font-bold">Company Address</span>}
          >
            <InputField
              placeholder={"Write Company Name"}
              name={"agencyAddress"}
              type={"text"}
              inputType={"both"}
            />
          </Form.Item>
          <Form.Item
            name="city"
            rules={[
              {
                required: true,
                message: "Please Enter Your City",
              },
            ]}
            label={
              <span className="text-base font-bold font-Almarai">City</span>
            }
          >
            <InputField
              placeholder={"Enter City Name"}
              name={"city"}
              type={"text"}
              inputType={"onlyCharacters"}
            />
          </Form.Item>
          <Form.Item
            name="state"
            rules={[
              {
                required: true,
                message: "Please Select your State",
              },
            ]}
            label={<span className="text-base font-bold">State</span>}
          >
            <Dropdown
              data={states}
              placeholder={"State"}
              className="rounded-lg"
            />
          </Form.Item>
          <Form.Item
            name="postalCode"
            rules={[
              {
                required: true,
                message: "Please Enter Postal Code",
              },
            ]}
            className="md:col-span-2"
            label={<span className="text-base font-bold">Postal Code</span>}
          >
            <InputField
              placeholder={"Enter Postal Code"}
              name={"postalCode"}
              type={"text"}
              inputType={"onlyNumbers"}
              maxLength={5}
            />
          </Form.Item>
          <Form.Item className="col-span-2">
            <Checkbox
              onChecked={setIsCheckboxChecked}
              onChange={handleCheckboxChange}
              fontColor="text-base font-medium"
              description={
                <span>
                  I agree to the
                  <span className="text-[#29A7EC] text-base font-medium">
                    {" "}
                    <Link to="/agent/privacy-policy" target="_blank">
                      Privacy Policy
                    </Link>
                  </span>{" "}
                  and
                  <span className="text-[#29A7EC] text-base font-medium">
                    {" "}
                    <Link to="/agent/terms-and-conditions" target="_blank">
                      Terms of Use
                    </Link>
                  </span>
                </span>
              }
            />
          </Form.Item>
          <Form.Item className="col-span-2">
            <div className="grid md:grid-cols-2 gap-5">
              <Link to="/agent/login">
                <Button
                  title="Already have an account? Login here"
                  type="secondary"
                />
              </Link>
              <Button
                title="Continue"
                htmlType="submit"
                type={isCheckboxChecked ? "primary" : "disabled"}
                disabled={!isCheckboxChecked}
                loading={loader}
              />
            </div>
          </Form.Item>
        </Form>
      </div>
    </LoginLayout>
  );
};

export default Registration;
